import type { FeatureFlagConfig } from '@platform/client/features';

declare module '@platform/core/feature-flags' {
  interface FeatureFlags {
    // AWN-303740
    ADS_ASSETS?: boolean;
    ADS_FULL_MOCKED?: boolean;
    ADS_ASSET_TAGS?: boolean;
    // AWN-1022275
    ADS_RISK_ADDITIONS?: boolean;
    ADS_GA_RELEASE?: boolean;
    UNIFIED_PORTAL_IA?: boolean;
    // PLAT-5202
    ADS_FENRIR_V2?: boolean;
    // AWN-167523 Risks in Unified Portal
    RISKS_IN_UP_WIP?: boolean;
    EVA_IN_UP_M1?: boolean;
  }
}

export default {
  featureFlags: {
    ADS_ASSETS: true,
    ADS_FULL_MOCKED: undefined,
    ADS_ASSET_TAGS: undefined,
    ADS_RISK_ADDITIONS: true,
    ADS_GA_RELEASE: true,
    UNIFIED_PORTAL_IA: true,
    ADS_FENRIR_V2: true,
    RISKS_IN_UP_WIP: undefined,
    EVA_IN_UP_M1: undefined,
  },
} satisfies FeatureFlagConfig;
